export const countriesData = [
  {
    name: "Afghanistan",
    currency: {
      name: "Afghani",
      abbreviation: "AFN",
      symbol: "؋",
    },
    calling_code: "93",
  },
  {
    name: "Albania",
    currency: {
      name: "Lek",
      abbreviation: "ALL",
      symbol: "Lek",
    },
    calling_code: "355",
  },
  {
    name: "Algeria",
    currency: {
      name: "Dinar",
      abbreviation: "DZD",
      symbol: "دج",
    },
    calling_code: "213",
  },
  {
    name: "Argentina",
    currency: {
      name: "Peso",
      abbreviation: "ARS",
      symbol: "$",
    },
    calling_code: "54",
  },
  {
    name: "Armenia",
    currency: {
      name: "Dram",
      abbreviation: "AMD",
      symbol: "֏",
    },
    calling_code: "374",
  },
  {
    name: "Aruba",
    currency: {
      name: "Guilder",
      abbreviation: "AWG",
      symbol: "ƒ",
    },
    calling_code: "297",
  },
  {
    name: "Australia",
    currency: {
      name: "Dollar",
      abbreviation: "AUD",
      symbol: "$",
    },
    calling_code: "61",
  },
  {
    name: "Austria",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "43",
  },
  {
    name: "Azerbaijan",
    currency: {
      name: "Manat",
      abbreviation: "AZN",
      symbol: "₼",
    },
    calling_code: "994",
  },
  {
    name: "Bahamas",
    currency: {
      name: "Dollar",
      abbreviation: "BSD",
      symbol: "$",
    },
    calling_code: "1242",
  },
  {
    name: "Bahrain",
    currency: {
      name: "Dinar",
      abbreviation: "BHD",
      symbol: ".د.ب",
    },
    calling_code: "973",
  },
  {
    name: "Bangladesh",
    currency: {
      name: "Taka",
      abbreviation: "BDT",
      symbol: "৳",
    },
    calling_code: "880",
  },
  {
    name: "Barbados",
    currency: {
      name: "Dollar",
      abbreviation: "BBD",
      symbol: "$",
    },
    calling_code: "1246",
  },
  {
    name: "Belarus",
    currency: {
      name: "Ruble",
      abbreviation: "BYN",
      symbol: "Br",
    },
    calling_code: "375",
  },
  {
    name: "Belgium",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€"
    },
    calling_code: "32"
  },
  {
    name: "Belize",
    currency: {
      name: "Dollar",
      abbreviation: "BZD",
      symbol: "BZ$",
    },
    calling_code: "501",
  },
  {
    name: "Bermuda",
    currency: {
      name: "Dollar",
      abbreviation: "BMD",
      symbol: "$",
    },
    calling_code: "1441",
  },
  {
    name: "Bolivia",
    currency: {
      name: "Boliviano",
      abbreviation: "BOB",
      symbol: "$",
    },
    calling_code: "591",
  },
  {
    name: "Bosnia and Herzegovina",
    currency: {
      name: "Convertible Mark",
      abbreviation: "BAM",
      symbol: "KM",
    },
    calling_code: "387",
  },
  {
    name: "Botswana",
    currency: {
      name: "Pula",
      abbreviation: "BWP",
      symbol: "P",
    },
    calling_code: "267",
  },
  {
    name: "Brazil",
    currency: {
      name: "Real",
      abbreviation: "BRL",
      symbol: "R$",
    },
    calling_code: "55",
  },
  {
    name: "Brunei Darussalam",
    currency: {
      name: "Dollar",
      abbreviation: "BND",
      symbol: "$",
    },
    calling_code: "673",
  },
  {
    name: "Bulgaria",
    currency: {
      name: "Lev",
      abbreviation: "BGN",
      symbol: "лв",
    },
    calling_code: "359",
  },
  {
    name: "Cambodia",
    currency: {
      name: "Riel",
      abbreviation: "KHR",
      symbol: "៛",
    },
    calling_code: "855",
  },
  {
    name: "Canada",
    currency: {
      name: "Dollar",
      abbreviation: "CAD",
      symbol: "$",
    },
    calling_code: "1",
  },
  {
    name: "Cayman Islands",
    currency: {
      name: "Dollar",
      abbreviation: "KYD",
      symbol: "$",
    },
    calling_code: "1345",
  },
  {
    name: "Chile",
    currency: {
      name: "Peso",
      abbreviation: "CLP",
      symbol: "$",
    },
    calling_code: "56",
  },
  {
    name: "China",
    currency: {
      name: "Yuan Renminbi",
      abbreviation: "CNY",
      symbol: "¥",
    },
    calling_code: "86",
  },
  {
    name: "Colombia",
    currency: {
      name: "Peso",
      abbreviation: "COP",
      symbol: "$",
    },
    calling_code: "57",
  },
  {
    name: "Costa Rica",
    currency: {
      name: "Colon",
      abbreviation: "CRC",
      symbol: "₡",
    },
    calling_code: "506",
  },
  {
    name: "Croatia",
    currency: {
      name: "Kuna",
      abbreviation: "HRK",
      symbol: "kn",
    },
    calling_code: "385",
  },
  {
    name: "Cuba",
    currency: {
      name: "Peso",
      abbreviation: "CUP",
      symbol: "₱",
    },
    calling_code: "53",
  },
  {
    name: "Cyprus",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "357",
  },
  {
    name: "Czech Republic",
    currency: {
      name: "Koruna",
      abbreviation: "CZK",
      symbol: "Kč",
    },
    calling_code: "420",
  },
  {
    name: "Denmark",
    currency: {
      name: "Krone",
      abbreviation: "DKK",
      symbol: "kr",
    },
    calling_code: "45",
  },
  {
    name: "Dominican Republic",
    currency: {
      name: "Peso",
      abbreviation: "DOP",
      symbol: "RD$",
    },
    calling_code: "1809",
  },
  {
    name: "East Caribbean",
    currency: {
      name: "Dollar",
      abbreviation: "XCD",
      symbol: "$",
    },
    calling_code: "1767",
  },
  {
    name: "Egypt",
    currency: {
      name: "Pound",
      abbreviation: "EGP",
      symbol: "£",
    },
    calling_code: "20",
  },
  {
    name: "El Salvador",
    currency: {
      name: "Colon",
      abbreviation: "SVC",
      symbol: "$",
    },
    calling_code: "503",
  },
  {
    name: "Estonia",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "372",
  },
  {
    name: "Falkland Islands",
    currency: {
      name: "Pound",
      abbreviation: "FKP",
      symbol: "£",
    },
    calling_code: "500",
  },
  {
    name: "Fiji",
    currency: {
      name: "Dollar",
      abbreviation: "FJD",
      symbol: "$",
    },
    calling_code: "679",
  },
  {
    name: "Finland",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "358",
  },
  {
    name: "France",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "33",
  },
  {
    name: "Georgia",
    currency: {
      name: "Lari",
      abbreviation: "GEL",
      symbol: "₾",
    },
    calling_code: "995",
  },
  {
    name: "Germany",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "49",
  },
  {
    name: "Ghana",
    currency: {
      name: "Cedi",
      abbreviation: "GHS",
      symbol: "¢",
    },
    calling_code: "233",
  },
  {
    name: "Gibraltar",
    currency: {
      name: "Pound",
      abbreviation: "GIP",
      symbol: "£",
    },
    calling_code: "350",
  },
  {
    name: "Greece",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "30",
  },
  {
    name: "Guatemala",
    currency: {
      name: "Quetzal",
      abbreviation: "GTQ",
      symbol: "Q",
    },
    calling_code: "502",
  },
  {
    name: "Guernsey",
    currency: {
      name: "Pound",
      abbreviation: "GGP",
      symbol: "£",
    },
    calling_code: "441481",
  },
  {
    name: "Guyana",
    currency: {
      name: "Dollar",
      abbreviation: "GYD",
      symbol: "$",
    },
    calling_code: "592",
  },
  {
    name: "Honduras",
    currency: {
      name: "Lempira",
      abbreviation: "HNL",
      symbol: "L",
    },
    calling_code: "504",
  },
  {
    name: "Hong Kong",
    currency: {
      name: "Dollar",
      abbreviation: "HKD",
      symbol: "$",
    },
    calling_code: "852",
  },
  {
    name: "Hungary",
    currency: {
      name: "Forint",
      abbreviation: "HUF",
      symbol: "Ft",
    },
    calling_code: "36",
  },
  {
    name: "Iceland",
    currency: {
      name: "Krona",
      abbreviation: "ISK",
      symbol: "kr",
    },
    calling_code: "354",
  },
  {
    name: "India",
    currency: {
      name: "Rupee",
      abbreviation: "INR",
      symbol: "₹",
    },
    calling_code: "91",
  },
  {
    name: "Indonesia",
    currency: {
      name: "Rupiah",
      abbreviation: "IDR",
      symbol: "Rp",
    },
    calling_code: "62",
  },
  {
    name: "Iran",
    currency: {
      name: "Rial",
      abbreviation: "IRR",
      symbol: "﷼",
    },
    calling_code: "98",
  },
  {
    name: "Iraq",
    currency: {
      name: "Dinar",
      abbreviation: "IQD",
      symbol: "ع.د",
    },
    calling_code: "964",
  },
  {
    name: "Ireland",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "353",
  },
  {
    name: "Isle of Man",
    currency: {
      name: "Pound",
      abbreviation: "IMP",
      symbol: "£",
    },
    calling_code: "44",
  },
  {
    name: "Israel",
    currency: {
      name: "Shekel",
      abbreviation: "ILS",
      symbol: "₪",
    },
    calling_code: "972",
  },
  {
    name: "Italy",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "39",
  },
  {
    name: "Jamaica",
    currency: {
      name: "Dollar",
      abbreviation: "JMD",
      symbol: "J$",
    },
    calling_code: "1876",
  },
  {
    name: "Japan",
    currency: {
      name: "Yen",
      abbreviation: "JPY",
      symbol: "¥",
    },
    calling_code: "81",
  },
  {
    name: "Jersey",
    currency: {
      name: "Pound",
      abbreviation: "JEP",
      symbol: "£",
    },
    calling_code: "441534",
  },
  {
    name: "Kazakhstan",
    currency: {
      name: "Tenge",
      abbreviation: "KZT",
      symbol: "лв",
    },
    calling_code: "7",
  },
  {
    name: "Korea (North)",
    currency: {
      name: "Won",
      abbreviation: "KPW",
      symbol: "₩",
    },
    calling_code: "850",
  },
  {
    name: "Korea (South)",
    currency: {
      name: "Won",
      abbreviation: "KRW",
      symbol: "₩",
    },
    calling_code: "82",
  },
  {
    name: "Kyrgyzstan",
    currency: {
      name: "Som",
      abbreviation: "KGS",
      symbol: "лв",
    },
    calling_code: "996",
  },
  {
    name: "Laos",
    currency: {
      name: "Kip",
      abbreviation: "LAK",
      symbol: "₭",
    },
    calling_code: "856",
  },
  {
    name: "Latvia",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "371",
  },
  {
    name: "Lebanon",
    currency: {
      name: "Pound",
      abbreviation: "LBP",
      symbol: "£",
    },
    calling_code: "961",
  },
  {
    name: "Liberia",
    currency: {
      name: "Dollar",
      abbreviation: "LRD",
      symbol: "$",
    },
    calling_code: "231",
  },
  {
    name: "Lithuania",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "370",
  },
  {
    name: "Luxembourg",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "352",
  },
  {
    name: "Macedonia",
    currency: {
      name: "Denar",
      abbreviation: "MKD",
      symbol: "ден",
    },
    calling_code: "389",
  },
  {
    name: "Malaysia",
    currency: {
      name: "Ringgit",
      abbreviation: "MYR",
      symbol: "RM",
    },
    calling_code: "60",
  },
  {
    name: "Malta",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "356",
  },
  {
    name: "Mauritius",
    currency: {
      name: "Rupee",
      abbreviation: "MUR",
      symbol: "₨",
    },
    calling_code: "230",
  },
  {
    name: "Mexico",
    currency: {
      name: "Peso",
      abbreviation: "MXN",
      symbol: "$",
    },
    calling_code: "52",
  },
  {
    name: "Mongolia",
    currency: {
      name: "Tughrik",
      abbreviation: "MNT",
      symbol: "₮",
    },
    calling_code: "976",
  },
  {
    name: "Mozambique",
    currency: {
      name: "Metical",
      abbreviation: "MZN",
      symbol: "MT",
    },
    calling_code: "258",
  },
  {
    name: "Namibia",
    currency: {
      name: "Dollar",
      abbreviation: "NAD",
      symbol: "$",
    },
    calling_code: "264",
  },
  {
    name: "Nepal",
    currency: {
      name: "Rupee",
      abbreviation: "NPR",
      symbol: "₨",
    },
    calling_code: "977",
  },
  {
    name: "Netherlands",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "31",
  },
  {
    name: "New Zealand",
    currency: {
      name: "Dollar",
      abbreviation: "NZD",
      symbol: "$",
    },
    calling_code: "64",
  },
  {
    name: "Nicaragua",
    currency: {
      name: "Cordoba",
      abbreviation: "NIO",
      symbol: "C$",
    },
    calling_code: "505",
  },
  {
    name: "Nigeria",
    currency: {
      name: "Naira",
      abbreviation: "NGN",
      symbol: "₦",
    },
    calling_code: "234",
  },
  {
    name: "Norway",
    currency: {
      name: "Krone",
      abbreviation: "NOK",
      symbol: "kr",
    },
    calling_code: "47",
  },
  {
    name: "Oman",
    currency: {
      name: "Rial",
      abbreviation: "OMR",
      symbol: "﷼",
    },
    calling_code: "968",
  },
  {
    name: "Pakistan",
    currency: {
      name: "Rupee",
      abbreviation: "PKR",
      symbol: "₨",
    },
    calling_code: "92",
  },
  {
    name: "Panama",
    currency: {
      name: "Balboa",
      abbreviation: "PAB",
      symbol: "/.",
    },
    calling_code: "507",
  },
  {
    name: "Paraguay",
    currency: {
      name: "Guarani",
      abbreviation: "PYG",
      symbol: "Gs",
    },
    calling_code: "595",
  },
  {
    name: "Peru",
    currency: {
      name: "Sol",
      abbreviation: "PEN",
      symbol: "S/.",
    },
    calling_code: "51",
  },
  {
    name: "Philippines",
    currency: {
      name: "Peso",
      abbreviation: "PHP",
      symbol: "₱",
    },
    calling_code: "63",
  },
  {
    name: "Poland",
    currency: {
      name: "Zloty",
      abbreviation: "PLN",
      symbol: "zł",
    },
    calling_code: "48",
  },
  {
    name: "Portugal",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "351",
  },
  {
    name: "Qatar",
    currency: {
      name: "Riyal",
      abbreviation: "QAR",
      symbol: "﷼",
    },
    calling_code: "974",
  },
  {
    name: "Romania",
    currency: {
      name: "Leu",
      abbreviation: "RON",
      symbol: "lei",
    },
    calling_code: "40",
  },
  {
    name: "Russia",
    currency: {
      name: "Ruble",
      abbreviation: "RUB",
      symbol: "₽",
    },
    calling_code: "7",
  },
  {
    name: "Saint Helena",
    currency: {
      name: "Pound",
      abbreviation: "SHP",
      symbol: "£",
    },
    calling_code: "290",
  },
  {
    name: "Saudi Arabia",
    currency: {
      name: "Riyal",
      abbreviation: "SAR",
      symbol: "﷼",
    },
    calling_code: "966",
  },
  {
    name: "Serbia",
    currency: {
      name: "Dinar",
      abbreviation: "RSD",
      symbol: "Дин.",
    },
    calling_code: "381",
  },
  {
    name: "Seychelles",
    currency: {
      name: "Rupee",
      abbreviation: "SCR",
      symbol: "₨",
    },
    calling_code: "248",
  },
  {
    name: "Singapore",
    currency: {
      name: "Dollar",
      abbreviation: "SGD",
      symbol: "$",
    },
    calling_code: "65",
  },
  {
    name: "Slovakia",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "421",
  },
  {
    name: "Slovenia",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "386",
  },
  {
    name: "Solomon Islands",
    currency: {
      name: "Dollar",
      abbreviation: "SBD",
      symbol: "$",
    },
    calling_code: "677",
  },
  {
    name: "Somalia",
    currency: {
      name: "Shilling",
      abbreviation: "SOS",
      symbol: "S",
    },
    calling_code: "252",
  },
  {
    name: "South Africa",
    currency: {
      name: "Rand",
      abbreviation: "ZAR",
      symbol: "R",
    },
    calling_code: "27",
  },
  {
    name: "Spain",
    currency: {
      name: "Euro",
      abbreviation: "EUR",
      symbol: "€",
    },
    calling_code: "34",
  },
  {
    name: "Sri Lanka",
    currency: {
      name: "Rupee",
      abbreviation: "LKR",
      symbol: "₨",
    },
    calling_code: "94",
  },
  {
    name: "Suriname",
    currency: {
      name: "Dollar",
      abbreviation: "SRD",
      symbol: "$",
    },
    calling_code: "597",
  },
  {
    name: "Sweden",
    currency: {
      name: "Krona",
      abbreviation: "SEK",
      symbol: "kr",
    },
    calling_code: "46",
  },
  {
    name: "Switzerland",
    currency: {
      name: "Franc",
      abbreviation: "CHF",
      symbol: "CHF",
    },
    calling_code: "41",
  },
  {
    name: "Syria",
    currency: {
      name: "Pound",
      abbreviation: "SYP",
      symbol: "£",
    },
    calling_code: "963",
  },
  {
    name: "Taiwan",
    currency: {
      name: "New Dollar",
      abbreviation: "TWD",
      symbol: "NT$",
    },
    calling_code: "886",
  },
  {
    name: "Thailand",
    currency: {
      name: "Baht",
      abbreviation: "THB",
      symbol: "฿",
    },
    calling_code: "66",
  },
  {
    name: "Trinidad and Tobago",
    currency: {
      name: "Dollar",
      abbreviation: "TTD",
      symbol: "TT$",
    },
    calling_code: "1868",
  },
  {
    name: "Turkey",
    currency: {
      name: "Lira",
      abbreviation: "TRY",
      symbol: "₺",
    },
    calling_code: "90",
  },
  {
    name: "Tuvalu",
    currency: {
      name: "Dollar",
      abbreviation: "TVD",
      symbol: "$",
    },
    calling_code: "688",
  },
  {
    name: "Ukraine",
    currency: {
      name: "Hryvnia",
      abbreviation: "UAH",
      symbol: "₴",
    },
    calling_code: "380",
  },
  {
    name: "United Arab Emirates",
    currency: {
      name: "Dirham",
      abbreviation: "AED",
      symbol: "د.إ",
    },
    calling_code: "971",
  },
  {
    name: "United Kingdom",
    currency: {
      name: "Pound",
      abbreviation: "GBP",
      symbol: "£",
    },
    calling_code: "44",
  },
  {
    name: "United States",
    currency: {
      name: "Dollar",
      abbreviation: "USD",
      symbol: "$",
    },
    calling_code: "1",
  },
  {
    name: "Uruguay",
    currency: {
      name: "Peso",
      abbreviation: "UYU",
      symbol: "$U",
    },
    calling_code: "598",
  },
  {
    name: "Uzbekistan",
    currency: {
      name: "Som",
      abbreviation: "UZS",
      symbol: "лв",
    },
    calling_code: "998",
  },
  {
    name: "Venezuela",
    currency: {
      name: "Bolívar",
      abbreviation: "VEF",
      symbol: "Bs",
    },
    calling_code: "58",
  },
  {
    name: "Viet Nam",
    currency: {
      name: "Dong",
      abbreviation: "VND",
      symbol: "₫",
    },
    calling_code: "84",
  },
  {
    name: "Yemen",
    currency: {
      name: "Rial",
      abbreviation: "YER",
      symbol: "﷼",
    },
    calling_code: "967",
  },
  {
    name: "Zimbabwe",
    currency: {
      name: "Dollar",
      abbreviation: "ZWD",
      symbol: "Z$",
    },
    calling_code: "263",
  },
];
